import React from 'react'

import EditTripDetailsGeneric from '../EditTripDetails/EditTripDetailsGeneric'

import noop from 'lib/noop'
import { FullTrip } from 'tripPlanner/types/common'

interface Props {
  trip: FullTrip
  onClose?: (trip: FullTrip) => void
}

function AdditionalDetails({ trip, onClose = noop }: Props) {
  return (
    <EditTripDetailsGeneric
      trip={trip}
      includeNameField={false}
      title="Success! Let’s add more details to your trip"
      subtitle="By sharing details about your trip, we’ll be able to personalise recommendations for things to do and places to see."
      saveLabel="Save trip details"
      cancelLabel="Maybe later"
      onClose={onClose}
    />
  )
}

export default AdditionalDetails
